import { Skeleton } from "@mui/material";
import { DDD, E2Data } from "../../lib/ddd/ddd";
import classes from "./DashboardComponents.module.scss";
import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { OrgIdContext, Domain } from "../../store/orgId_context";
import ButtonLink from "../UI/ButtonLink";
import { useTranslation } from 'react-i18next';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const e2Data = new E2Data("EU_AOrg_Packages");
e2Data.format = "Full";


const SimplePanel = ({title, amount, tooltip, amount2, colclass, amount1Tooltip, amount2Tooltip,slashTooltip}) => {
    const {sessionInfo, domain} = useContext(OrgIdContext);
    const { t } = useTranslation();

    return (<>
    <div className={classes.container} style={{textAlign:"center"}}>
    <Row>
        <Col>
            <div className="d-flex justify-content-center flex-nowrap">
                <h4 className={`mt-2 ${classes.subtitle}`} style={{fontSize:"0.9rem"}}>{title}</h4>
                {tooltip && <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
                    <HelpOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem"}}/>
                </OverlayTrigger>}
            </div>
        </Col>
    </Row>
    <Row>
        <Col className={colclass}>
            <h3>{amount1Tooltip ? (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{amount1Tooltip}</Tooltip>}
                >
                    <span>{amount}</span>
                </OverlayTrigger>
                ) : (
                amount
                )}

                {amount2 !== undefined && (
                <>
                    {slashTooltip ? (<OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{slashTooltip}</Tooltip>}
                    >
                        <span>/</span>
                    </OverlayTrigger>) : (<>/</>)}
                    {amount2Tooltip ? (
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{amount2Tooltip}</Tooltip>}
                    >
                        <span style={{ color: "var(--main-orange)" }}>
                        {amount2}
                        </span>
                    </OverlayTrigger>
                    ) : (
                    <span style={{ color: "var(--main-orange)" }}>{amount2}</span>
                    )}
                </>
                )}
            </h3>
        </Col>
    </Row>
    </div>
    </>);
}

export default SimplePanel;